export default {
  newDesign: true,
  parameters: {
    landing_id: "LatamQMine",
    segment: 14,
    success_page: "success_long",
  },
  title:
    "Responde unas preguntas rápidas para obtener acceso a tu clase de prueba gratuita. | Kodland",
  downtimeUrl: "https://www.kodland.org/es",
  startPage: {
    title:
      "Responde unas preguntas rápidas para obtener acceso a tu clase de prueba gratuita.",
      image: {
      url: "/welcome/latam_mine_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/latam_mine_mob.png",
      style: {
        width: "100%",
      },
    },
    button: "Empezar el quiz 🚀",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "¡Gracias por confiar en nuestra plataforma educativa!",
    subtitle:
      "Lamentablemente, las tabletas y los teléfonos no son adecuados para nuestras clases. ¡Esperamos verte en nuestras lecciones en otra ocasión!",
  },
  customStopPages: {
    child: {
      title: "Lamentablemente, solo un padre, madre o tutor puede inscribir a un estudiante en las clases.",
      subtitle:
        "Si quieres continuar, puedes compartir este enlace con tus padres. ¡Esperamos verte pronto en nuestras clases!",
      image: "/welcome/quizV2/child-parent.png",
    },
  },
  quizRotateBySteps: {
    1: {
      question: "¿Eres mamá, papá, otro familiar o hijo/a?",
      answers: [
        "👨‍🦱Soy papá",
        "👩‍🦰Soy mamá",
        "👵Soy otro familiar / tutor",
        {
          answer: "👧🧒Soy hijo/a",
          stopAnswer: true,
          customStopPageId: "child",
        },
      ],
    },
2: {
  question:
    "¿Cómo describirías la personalidad de tu hijo o hija?",
    // could a subtitle be here?
    subtitle: "Esto nos ayuda a elegir el mejor estilo de enseñanza.",
  answers: [
    "🐶 Enérgico/a y hablador/a",
    "🌙 Soñador/a e imaginativo/a",
    "🤔 Aún está descubriendo lo que le gusta",
    "😳 Tímido/a",
    "🌱 Tranquilo/a y prefiere actividades individuales",
  ],
},
3: {
  question: "¿Qué te gustaría que tu hijo o hija obtuviera del curso?",
  answers: [
    "🎮 Divertirse mientras aprende",
    "👩‍💻 Aprender habilidades tecnológicas reales",
    "🧠 Mejorar la concentración y la disciplina",
    "📱 Usar el tiempo frente a la pantalla de forma más productiva",
    "🍀 Descubrir lo que le gusta",
    "💬 Desarrollar la creatividad y la comunicación",
  ],
},
    4: {
      question: "¿Tienes una computadora de escritorio/portátil donde puedas trabajar?",
      answers: [
        
        "💻 Sí",
        {
          answer: "😐 No",
          stopAnswer: true
        },
      ],
    },
    5: {
      title: "¿Cuántos años tiene tu hijo?",
      type: "age",
      button: "",
    },
    6: {
      typeInfo: "congrats",
      title: "🎉 ¡Todo listo para tu clase gratis!",
      subtitle:
        "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
      button: "📅 Agendar clase gratis",
    },
    7: {
      title: "Inscríbete a una clase de prueba gratuita",
      type: "one-page-contacts",
      subtitle:
        "Conversemos, conoce nuestro método y descubre todo lo que tu hijo puede aprender con nosotros.",
      button: "Casi terminamos 🔥",
    },
    8: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    9: {
      title: "Revisa estos detalles para completar el registro ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
      button: "¿Qué más?",
    },
    10: {
      title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
      typeInfo: "whatsapp",
      subtitle:
        "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
      button: "¿Qué más?",
    },
    11: {
      title: "La clase se realizará en nuestra plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo haz clic en el enlace y te llevará directo a la clase. Sin apps adicionales, sin descargas.",
      button: "Entendido ✅",
    },
  },
};
